import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Form } from 'antd';
import { useTranslation } from 'react-i18next';
import { ColumnGroup, Column, Card } from '@cards/Card';
import { selectHospitalFromList } from '@redux/hospitals/reducers';
import { loadOrgConfig } from '@integrations/redux/actions';
import { selectOrgConfig } from '@integrations/redux/reducers';
import './styles.less';

const detailsLayout = {
  labelCol: {
    span: 6,
  },
  layout: 'vertical',
  wrapperCol: {
    span: 18,
  },
};

function KemtaiAdminView({
  form: { getFieldDecorator },
  match: {
    params: { id },
  },
}) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [hasLoaded, setHasLoaded] = useState(false);

  const [, hospital] = useSelector(selectHospitalFromList(id));
  const [, orgConfig] = useSelector(selectOrgConfig('kemtai'));

  useEffect(() => {
    if (!hospital || hasLoaded) {
      return;
    }
    dispatch(loadOrgConfig('kemtai', hospital.slug));
    setHasLoaded(true);
  }, [dispatch, hasLoaded, setHasLoaded, hospital]);

  return (
    <ColumnGroup className="edit-organisation-branding-details">
      <Column>
        <Card
          className="organisation-details-form-card"
          title={
            <div className="kemtai-admin-view-title">
              <p>{t('kemtai:organisationConfig.title')}</p>
              <p className="description">
                {t('kemtai:organisationConfig.description', { kemtaiCare: 'Kemtai Care' })}
              </p>
            </div>
          }
        >
          <Form {...detailsLayout}>
            <Form.Item className="details-item" label={t('kemtai:adminView.isEnabled')}>
              {getFieldDecorator('isEnabled')(
                <span>
                  {orgConfig && orgConfig.isEnabled
                    ? t('kemtai:adminView.yes')
                    : t('kemtai:adminView.no')}
                </span>,
              )}
            </Form.Item>
          </Form>
        </Card>
      </Column>
    </ColumnGroup>
  );
}

const WrappedKemtaiAdminView = Form.create()(KemtaiAdminView);

export default WrappedKemtaiAdminView;
